import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '@/api/client';
import { Icon } from '@/components/Icon';
import { NotificationView } from './NotificationView';
import s from './NotificationCenter.module.css';

export function NotificationCenter({ tablet = false }: { tablet?: boolean }) {
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  const setCount = useCallback((count: number) => setUnread(count), []);
  useEffect(() => {
    let active = true;
    const load = () => { void api.get<{ unreadCount: number }>('/api/v2/notifications').then((result) => { if (active) setUnread(result.unreadCount); }).catch(() => undefined); };
    load();
    window.addEventListener('ims:v2:notification', load);
    return () => { active = false; window.removeEventListener('ims:v2:notification', load); };
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return <>
    <button className={tablet ? s.railButton : s.button} type="button" aria-label={unread ? `通知中心，${unread} 条未读` : '通知中心'} aria-expanded={open} onClick={() => setOpen(true)}>
      <Icon name={tablet ? 'bell' : 'msg'} size={20} />
      {!!unread && <span className={s.dot} aria-hidden="true" />}
    </button>
    {open && <div className={`${s.scrim} ${tablet ? s.tabletScrim : ''}`} onClick={() => setOpen(false)}>
      <section className={`${s.panel} ${tablet ? s.tabletPanel : ''}`} role="dialog" aria-modal="true" aria-label="通知中心" onClick={(event) => event.stopPropagation()}>
        <NotificationView onClose={() => setOpen(false)} onUnreadChange={setCount} tabletPopover={tablet} />
      </section>
    </div>}
  </>;
}

export function NotificationsPage() {
  const navigate = useNavigate();
  return <div className={s.page}><NotificationView onClose={() => navigate('/')} /></div>;
}
